var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"chips":"","items":_vm.itemsValue,"label":'Pick your brand (required)',"hint":"Pick your brand","item-text":"name","item-value":"id","menu-props":"auto","persistent-hint":""},model:{value:(_vm.brandId),callback:function ($$v) {_vm.brandId=$$v},expression:"brandId"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }